module.exports = __webpack_public_path__ + "static/media/ENVI.da2a2ad2.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/ENVI.jpg
// module id = 1738
// module chunks = 1